import {
    EnteredValueTextFieldStyleProps,
    EnteredValueTextFieldStyles,
} from './SelectableTextField.types';

export function getEnteredValueTextFieldStyles(
    props: EnteredValueTextFieldStyleProps
): EnteredValueTextFieldStyles {
    const { theme, focused } = props;

    return {
        fieldGroup: [
            focused && {
                borderColor: theme.palette.themeDark,
            },
        ],
    };
}
